import { skipToken, useMutation, useQuery } from "@tanstack/react-query";
import { baseApi } from "./baseApi";
import { engineApi } from "./engineApi";

export const useGetPredictionMarketEventDetails = () => {
  return useMutation({
    mutationKey: ["prediction_market_event_details"],
    mutationFn: async ({ userId, ticker }: { userId: string; ticker: string }) => {
      const response = await baseApi.get(
        `/prediction_market_event_details?user_id=${userId}&event_ticker=${ticker}`
      );
      return response.data;
    },
  });
};

export const useGetPredictionMarketCandlesticks = (
  userId?: string,
  ticker?: string,
  seriesTicker?: string,
  dateFrom?: string,
  dateTo?: string,
  interval?: string,
) => {
  return useQuery({
    queryKey: [
      "prediction_market_candlesticks",
      userId,
      ticker,
      seriesTicker,
      dateFrom,
      dateTo,
      interval,
    ],
    queryFn:
      !userId || !ticker || !seriesTicker || !dateFrom || !dateTo || !interval
        ? skipToken
        : async () => {
            const response = await baseApi.get(
              `/prediction_market_candlesticks?user_id=${userId}&ticker=${ticker.toLowerCase()}&series_ticker=${seriesTicker.toUpperCase()}&date_from=${dateFrom}&date_to=${dateTo}&period_interval=${interval}`
            );
            return response.data;
          },
    retry: 0,
    staleTime: 5000,
  });
};

export const useGetPredictionMarketEventAnalytics = (ticker?: string) => {
  return useQuery({
    queryKey: ["prediction_market_event_analytics", ticker],
    queryFn: !ticker
      ? skipToken
      : async () => {
          const response = await engineApi.get(
            `/prediction_markets/get_event_analytics?ticker=${ticker}`
          );
          return response.data;
        },
    retry: 0,
    staleTime: 5000,
  });
};

export const useGetTrendingEvents = (userId?: string) => {
  return useQuery({
    queryKey: ["get_trending_events", userId],
    queryFn: !userId
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/get_trending_events?user_id=${userId}`
          );
          return response.data;
        },
    retry: 0,
    staleTime: 30000,
  });
};

export const useGetPredictionMarketStrictSl = (userId?: string, strategyId?: string) => {
  return useQuery({
    queryKey: ["prediction_market_strict_sl", userId, strategyId],
    queryFn: !userId || !strategyId
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/prediction_market_strict_sl?user_id=${userId}&strategy_id=${strategyId}`
          );
          return response.data;
        },
    enabled: !!userId && !!strategyId,
  });
};

export const useGetProfitabilityByEntryProbability = (userId?: string, deploymentId?: string) => {
  return useQuery({
    queryKey: ["get_profitability_by_entry_probability", userId, deploymentId],
    queryFn: !userId || !deploymentId
      ? skipToken
      : async () => {
          const response = await baseApi.get(
            `/get_profitability_by_entry_probability?user_id=${userId}&deployment_id=${deploymentId}`
          );
          return response.data;
        },
    enabled: !!userId && !!deploymentId,
  });
};

export const useGetPredictionMarketTrendingEvents = (userId?: string, page = 1, size = 10) => {
  return useQuery({
    queryKey: ["get_prediction_market_trending_events", userId, page, size],
    queryFn: async () => {
      const response = await baseApi.get(
        `/get_prediction_market_trending_events?user_id=${userId || "SWDZyl"}&page=${page}&size=${size}`
      );
      return response.data;
    },
    retry: 1,
    staleTime: 30000,
  });
};


